import Bookmarklet from './Bookmarklet';

export default Bookmarklet;
